"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTabDropdown = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _lodash = require("lodash");
var _space = require("../../styles/variables/_space");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _clickAway = require("../../utils/click-away");
var _mergeRefs = require("../../utils/merge-refs");
var _qa = require("../../utils/qa");
var _ButtonTab = require("./ButtonTab");
var _Menu = require("../Menu");
var _Tooltip = require("../Tooltip");
var _ButtonTabDropdownModule = _interopRequireDefault(require("./ButtonTabDropdown.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ButtonTabDropdown = _ref => {
  let {
    title,
    elevation = 'modal',
    anchorPosition = 'bottom-end',
    testId,
    ...buttonTabProps
  } = _ref;
  const {
    size,
    children,
    selectedButtonTabId,
    onButtonTabSelect: onTabSelect,
    dropdownClass
  } = buttonTabProps;
  const childrenArray = React.Children.toArray(children);
  const menuOptions = childrenArray.map(child => {
    const {
      id,
      children,
      disabled,
      iconName,
      iconType,
      classNames,
      size: buttonSize
    } = child.props;
    return {
      key: id,
      disabled,
      classNames,
      label: children,
      iconLeft: iconName,
      iconLeftType: iconType,
      customComponent: children,
      optionSize: buttonSize ?? size
    };
  });
  const moreTabSelectedId = (0, _lodash.includes)(menuOptions.map(_ref2 => {
    let {
      key
    } = _ref2;
    return key;
  }), selectedButtonTabId) ? 'more-tab' : selectedButtonTabId;
  const {
    x,
    y,
    refs,
    strategy,
    context
  } = (0, _react2.useFloating)({
    open: true,
    strategy: 'absolute',
    placement: anchorPosition,
    whileElementsMounted: _react2.autoUpdate,
    middleware: [(0, _react2.shift)(), (0, _react2.flip)(), (0, _react2.offset)(parseInt(_space.spaceXXSmall))]
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_clickAway.ClickAway, {
    children: _ref3 => {
      let {
        isOpen,
        onOpen,
        clickAway,
        boundaryRef,
        triggerRef
      } = _ref3;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'root'
        }),
        className: (0, _classify.default)(_ButtonTabDropdownModule.default.buttonTabDropDownWrapper, dropdownClass),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonTab.ButtonTab, {
          ...buttonTabProps,
          ref: (0, _mergeRefs.mergeRefs)([refs.setReference, triggerRef]),
          selectedButtonTabId: moreTabSelectedId,
          onButtonTabSelect: (_id, e) => {
            e?.stopPropagation();
            onOpen();
          },
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'button'
          }),
          children: title
        }), isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingPortal, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.FloatingFocusManager, {
            modal: false,
            context: context,
            initialFocus: refs.reference,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: _ButtonTabDropdownModule.default.menuWrapper,
              ref: (0, _mergeRefs.mergeRefs)([refs.setFloating, boundaryRef]),
              "data-testid": (0, _qa.generateTestId)({
                base: testId,
                slot: 'menu-wrapper'
              }),
              style: {
                display: 'flex',
                position: strategy,
                top: y ?? _space.spaceNone,
                left: x ?? _space.spaceNone,
                '--menu-elevation': (0, _Tooltip.getElevationValue)(elevation)
              },
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
                onSelect: (option, e) => {
                  onTabSelect?.(option.key, e);
                  clickAway();
                },
                size: size,
                options: menuOptions,
                onTabOut: clickAway,
                selectedKeys: [selectedButtonTabId ?? ''],
                testId: (0, _qa.generateTestId)({
                  base: testId,
                  slot: 'menu'
                })
              })
            })
          })
        })]
      });
    }
  });
};
exports.ButtonTabDropdown = ButtonTabDropdown;